/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Cost_GuideInputs */

const en_landing_studio_cost_guide = /** @type {(inputs: Landing_Studio_Cost_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cost guide`)
};

const zh_landing_studio_cost_guide = /** @type {(inputs: Landing_Studio_Cost_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格说明`)
};

/**
* | output |
* | --- |
* | "Cost guide" |
*
* @param {Landing_Studio_Cost_GuideInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_cost_guide = /** @type {((inputs?: Landing_Studio_Cost_GuideInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Cost_GuideInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_cost_guide(inputs)
	return zh_landing_studio_cost_guide(inputs)
});
export { landing_studio_cost_guide as "landing.studio.cost_guide" }